/**
 * The type of (redux) action which stores the view zoom another participant
 * applied to their own camera or screenshare.
 *
 * {
 *     type: REMOTE_VIDEO_ZOOM_CHANGED,
 *     participantId: string,
 *     videoType: string,
 *     zoomState: Object
 * }
 */
export const REMOTE_VIDEO_ZOOM_CHANGED = 'REMOTE_VIDEO_ZOOM_CHANGED';

/**
 * The type of (redux) action which records the view zoom the local
 * participant applied to their own camera or screenshare. The middleware
 * sends it to the other participants.
 *
 * {
 *     type: LOCAL_VIDEO_ZOOM_CHANGED,
 *     videoType: string,
 *     zoomState: Object
 * }
 */
export const LOCAL_VIDEO_ZOOM_CHANGED = 'LOCAL_VIDEO_ZOOM_CHANGED';

/**
 * The type of (redux) action asking the large video to zoom the local video
 * on stage to a specific level (the 1x / 2x / ... button).
 *
 * {
 *     type: REQUEST_VIEW_ZOOM,
 *     zoom: number,
 *     nonce: number
 * }
 */
export const REQUEST_VIEW_ZOOM = 'REQUEST_VIEW_ZOOM';

/**
 * The type of (redux) action which records whether the local user approved sharing
 * their local video zoom with all participants.
 *
 * {
 *     type: SET_LOCAL_ZOOM_SHARE_APPROVED,
 *     approved: boolean
 * }
 */
export const SET_LOCAL_ZOOM_SHARE_APPROVED = 'SET_LOCAL_ZOOM_SHARE_APPROVED';

/**
 * The type of (redux) action which records whether a moderator approved sharing
 * moderator pin zoom with all participants.
 *
 * {
 *     type: SET_MODERATOR_ZOOM_SHARE_APPROVED,
 *     approved: boolean
 * }
 */
export const SET_MODERATOR_ZOOM_SHARE_APPROVED = 'SET_MODERATOR_ZOOM_SHARE_APPROVED';
